import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
interface ProductCardProps {
  title: string;
  description: string;
  imageLabel: string;
  linkTo: string;
  price?: string;
  imageUrl?: string;
}
export function ProductCard({
  title,
  description,
  imageLabel,
  linkTo,
  price,
  imageUrl
}: ProductCardProps) {
  return <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow flex flex-col h-full" data-id="element-87">
      <div className="h-80 bg-gray-50 flex items-center justify-center relative overflow-hidden" data-id="element-88">
        {imageUrl ? <img src={imageUrl} alt={title} className="w-full h-full object-contain p-6" data-id="element-89" /> : <span className="text-gray-500 font-bold text-lg" data-id="element-90">{imageLabel}</span>}
        {price && <div className="absolute top-4 right-4 bg-brand-yellow text-brand-dark font-bold px-3 py-1 rounded-full text-sm" data-id="element-91">
            {price}
          </div>}
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-92">
        <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-93">{title}</h3>
        <p className="text-gray-600 mb-6 flex-grow" data-id="element-94">{description}</p>
        <Link to={linkTo} className="mt-auto" data-id="element-95">
          <Button variant="primary" fullWidth className="group" data-id="element-96">
            View Kit
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-97" />
          </Button>
        </Link>
      </div>
    </div>;
}